<template>
    <div>
        <div
            id="restaurant-list-filters-label"
            class="h7 before-after:content-[''] before-after:bg-primary/25 before-after:grow before-after:h-0.5 before-after:w-full before-after:block hidden items-center justify-center gap-x-3.5 whitespace-nowrap lg:flex"
        >
            Filter By Brand
        </div>

        <menu aria-labelledby="restaurant-list-filters-label" class="mt-3 hidden flex-wrap justify-center gap-x-3 gap-y-3 pb-6 lg:flex xl:justify-between">
            <li v-for="concept in concepts" :key="`restaurant-list-filter-${concept.slug}`">
                <RouterLink
                    :to="activeFilter == concept.slug ? '/restaurants' : `/restaurants/${concept.slug}`"
                    :class="[
                        activeFilter && activeFilter != concept.slug ? 'opacity-50 grayscale' : '',
                        'flex h-15 items-center justify-center transition-all hover:opacity-50 hover:grayscale-100 aria-current:opacity-100 aria-current:grayscale-0',
                    ]"
                    :aria-current="concept.slug == activeFilter"
                    :data-tippy-content="concept.name"
                >
                    <component :is="conceptLogoComponent(concept.slug)" :class="`restaurant-list-logo-${concept.slug}`"></component>
                    <span class="sr-only">{{ concept.name }}</span>
                </RouterLink>
            </li>
        </menu>

        <div class="flex flex-col gap-2 pb-6 sm:flex-row sm:items-center lg:hidden">
            <div class="h7 whitespace-nowrap">Filter by Brand</div>

            <VueSelect
                v-model="dropdownValue"
                class="grow"
                :components="{ OpenIndicator: DropdownArrowIcon }"
                :options="dropdownOptions"
                :clearable="false"
                :reduce="(cpt) => cpt.value"
                :append-to-body="true"
                placeholder="Select a Brand"
            ></VueSelect>
        </div>
    </div>
</template>

<script setup>
import { useRestaurantsListStore } from '../../stores/restaurant-list-store';
import { pascalCase } from '../../utils/strings';
import Logos from '../../../images/logos';
import { storeToRefs } from 'pinia';
import { RouterLink, useRouter } from 'vue-router';
import { onMounted, watch } from 'vue';
import tippy, { roundArrow } from 'tippy.js';
import VueSelect from 'vue-select';
import { ref } from 'vue';
import { computed } from 'vue';
import DropdownArrowIcon from '../../../images/icons/dropdown-arrow.svg';

const router = useRouter();

const store = useRestaurantsListStore();

const { activeFilter } = storeToRefs(store);
const { concepts } = store;

const dropdownValue = ref(activeFilter);

const dropdownOptions = computed(() => {
    let options = concepts.map((cpt) => {
        return {
            label: cpt.name,
            value: cpt.slug,
        };
    });

    options.unshift({
        label: 'All Brands',
        value: null,
    });

    return options;
});

watch(dropdownValue, (value) => {
    if (value) {
        router.push({ path: `/restaurants/${value}` });
    } else {
        router.push({ path: `/restaurants/` });
    }
});

/**
 * Retrieve the concept logo component by slug.
 *
 * @param   {string}    slug The concept slug.
 * @returns {component}      The concept logo component.
 */
function conceptLogoComponent(slug) {
    return Logos[pascalCase(`${slug}-logo`)];
}

onMounted(() => {
    tippy('[data-tippy-content]', {
        duration: 150,
        delay: [150, 0],
        placement: 'bottom',
        arrow: roundArrow,
    });
});
</script>

<style>
.restaurant-list-logo-dot-coffee {
    height: 100%;
}
.restaurant-list-logo-pappadeaux {
    height: 48%;
}
.restaurant-list-logo-pappasitos {
    height: 62.5%;
}
.restaurant-list-logo-pappas-bbq {
    height: 84.125%;
}
.restaurant-list-logo-pappas-bros {
    height: 50%;
}
.restaurant-list-logo-pappas-burger {
    height: 77.416667%;
}
.restaurant-list-logo-pappas-delta-blues {
    height: 67.9375%;
}
.restaurant-list-logo-pappas-seafood {
    height: 87.041667%;
}
.restaurant-list-logo-littles-oyster-bar {
    height: 69.020833%;
}
.restaurant-list-logo-yiayias {
    height: 72.916667%;
}
</style>
